<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Intent To Submit</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-filter">
                           <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                           <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/ExpressionInterests/MenuList.vue";
import lang from "@/views/modules/ExpressionInterests/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/ExpressionInterests/ListView.vue";
import CustomSearch from "@/views/modules/ExpressionInterests/SearchView.vue";
export default {
name: "list-Intent-To-Submit",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    CustomSearch,
    },
    data(){
        return{
            generic: true,
            isActive:false,
            metaList:[
                {
                    label: lang.LBL_EOI_NO,
                    link:true,
                    width:150,
                    moduleName:'ExpressionInterests',/// moduleName is required
                    routePath:'exinterests',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'eoi_no'
                },
                {
                    label: lang.LBL_OPPORTUNITY_TITLE,
                    link:false,
                    width:150,
                    moduleName:'ExpressionInterests',/// moduleName is required
                    routePath:'exinterests',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'opportunity_title'
                },
                {
                    label: lang.LBL_DEADLINE,
                    link:false,
                    width:150,
                    routePath:'',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'deadline'
                },
                {
                    label: lang.LBL_ON_DATE,
                    width:150,
                    link:true,
                    moduleName:'ExpressionInterests',/// moduleName is required
                    routePath:'exinterests',
                    isSort: true,
                    field_name: 'submited_on'
                },
                {
                    label: lang.LBL_EOI_BY,
                    link:false,
                    width:150,
                    moduleName:'ExpressionInterests',/// moduleName is required
                    routePath:'exinterests',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'eoi_by'
                },
                {
                    label: lang.LBL_NOTE,
                    width:200,
                    link:true,
                    moduleName:'ExpressionInterests',
                    routePath:'exinterests',
                    isSort: true,
                    field_name: 'eoi_note'
                },
                {
                    label: lang.LBL_STATUS,
                    width:300,
                    link:false,
                    routePath:''
                },
            ],
            columns: ['eoi_no','opportunity_title', 'deadline', 'submited_on', 'eoi_by', 'eoi_note', 'status'],

        }
    },
    mounted() {
        this.childMethod();
        this.$emit('MetaView','Awesome')
    },
    methods:{
        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        }, 
    }
}

</script>



